import { PresentationMode } from '../../common/enums';
import { AppConfig } from '../../models/config/app-config';

export const videxCVisumConfig: AppConfig = {
  umgebung: 'VIDEX',
  visumAntragsartEnum: 'KURZFRISTIGER_AUFENTHALT',

  // Diese Property wird durch einen vom Backend abgefragten Wert überschrieben
  // (siehe cfg-videx-kurzfristiger-aufenthalt.component.ts und ap2mode.service.ts).
  // Im Backend wird der Ap2Mode durch die Datei active_visum_langfristiger_aufenthalt.cfg in %KARAF_HOME%\etc bzw.
  // %LOCALAPPDATA%\VIDEX\etc bestimmt (siehe VisumLangfristigerAufenthaltNonVaadinApplicationContentProvider).
  presentationMode: PresentationMode.DEFAULT,

  defaults: {
    referenz: {
      art: '2'
    },
    // vorbelegung der Zwischenobjeckte, da kostenuebername sonst null ist
    kostenuebernahme: {
      reisekostenUebernahme: {},
      lebensunterhalt: {},
      verpflichtungserklaerungsgeber: { art: '1' }
    },
    angabenZurPerson: {
      beruf: {}
    }
  },

  isImportActive: true, // Nur in VIDEX
  isAssistantAvailable: true, // Nur in VIDEX
  isDokumenteActive: false, // In VIDEX gibt es keine Biometrie-Erfassung
  isLichtbildActive: false, // In VIDEX gibt es keine Biometrie-Erfassung
  isFingerabdruckActive: false, // In VIDEX gibt es keine Biometrie-Erfassung
  isZusaetzlicheAngabenActive: false,
  isKostenuebernahmeActive: true,
  isReisedatenKurzfristigerAufenthaltActive: true
};
